import React, { useEffect } from "react";
import { setCustomerAuthenticate } from "../../services/redux/CustomerAuthentication";
import { useDispatch } from "react-redux";
import { setDetailsData } from "../../services/redux/DetailsReducer";
import { setCustomerData } from "../../services/redux/CustomerDataReducer";
import LogoDiv from "../Common/LogoDiv";
import { setSuccessPage } from "../../services/redux/SuccessReducer";


export default function SessionExpired() {

    return (
        <>
            <body className='mailsentbody'>
                <LogoDiv className="logoBG">
                    <div className="rightElement">
                        <div className="grid mt-6 grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                            <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                                <div className='bg-white mx-2 shadow-2xl p-6 mt-14 rounded-lg'>
                                    <div className="py-2 mt-3 text-center">
                                        <h1 className="text-xl font-semibold letter-spacing">SESSION EXPIRED!

                                        </h1>
                                    </div>
                                    {/* <div className="flex justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#A5DC86" style={{ width: '100px' }}>
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                        </svg>
                                    </div> */}
                                    <div className="py-5"></div>
                                    <div className="text-center mt-4 mb-3">
                                        <label className="text-xl font-normal text-gray-500">
                                            Please login in your account to continue with your application.
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                        </div>
                    </div>
                </LogoDiv>
            </body>
        </>
    );
}